import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { usePartnerShares } from '../context/PartnerSharesContext';
import PartnerSharesTable from './PartnerSharesTable';

const PartnerSharesBody: FC = () => {
  const { data, actions } = usePartnerShares();

  const showPagination = data.shares && data.totalShares > 10;

  return (
    <>
      <PartnerSharesTable />

      {showPagination && (
        <TablePagination
          totalRows={data.totalShares || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default PartnerSharesBody;
